// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UV6K","newExpiryDate":"styles_newExpiryDate__2wQoy","footer":"styles_footer__3Vftt"};